import { Link } from 'react-router-dom';

import { SmartTableCellProps } from '@/components/ui/daisy';
import { handleUserFullName } from '@/functions/handleUserFullName';
import { ROUTES } from '@/utils/routes';

import ActivityProgress from '@/models/ActivityProgress';

export default function StudentCell({
  item,
}: SmartTableCellProps<Pick<ActivityProgress, 'student'>>) {
  const { student } = item;

  if (!student) return null;

  return (
    <Link
      to={ROUTES.ADMIN.STUDENTS.INFO({ idIn: String(student.id) })}
      className="text-primary underline"
    >
      {handleUserFullName(student)}
    </Link>
  );
}
